import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { sendEmailVerification } from "firebase/auth";
import styles from "../Signup/SignUp.module.css";
import { notify } from "../toast";
import { auth, firebaseEmailContinueUrl, hasFirebaseConfig } from "../../../config/firebase";
import AuthShell from "../AuthShell";

const EmailSent = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const email = location.state?.email;
  const [isResending, setIsResending] = useState(false);

  const resendVerificationLink = async () => {
    if (!hasFirebaseConfig || !auth) {
      notify(t("auth.firebaseNotConfigured"), "error");
      return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) {
      notify(t("auth.signInAgainForResend"), "warning");
      return;
    }

    if (currentUser.emailVerified) {
      notify(t("auth.emailAlreadyVerified"), "success");
      return;
    }

    try {
      setIsResending(true);
      await sendEmailVerification(currentUser, {
        url: firebaseEmailContinueUrl,
      });
      notify(t("auth.verificationResent"), "success");
    } catch (error) {
      notify(t("auth.resendError"), "error");
    } finally {
      setIsResending(false);
    }
  };

  return (
    <AuthShell subtitle={t("auth.brandPanelEmailSent")}>
      <div className={styles.formLogin}>
        <h2>{t("auth.verificationEmailSent")}</h2>
        <p className={styles.messageBlock}>{t("auth.verificationLinkSent")}</p>
        {email && (
          <p className={styles.messageEmail}>
            {t("auth.emailLabel")}: {email}
          </p>
        )}
        <p className={styles.messageBlock}>{t("auth.checkInbox")}</p>
        <div className={styles.actions}>
          <button
            className={styles.primaryBtn}
            type="button"
            onClick={resendVerificationLink}
            disabled={isResending}
          >
            {isResending ? t("auth.sending") : t("auth.resendVerification")}
          </button>
          <Link className={styles.secondaryBtn} to="/login">
            {t("auth.goToLogin")}
          </Link>
        </div>
      </div>
      <ToastContainer />
    </AuthShell>
  );
};

export default EmailSent;
